export default function Error({ message }) {
  return (
    <p className=" animate-pulse duration-1000 absolute left-1/2 top-1/2 ">
      <span>⛔</span> {message}
    </p>
  );
}